<style>
.measure-button,
.info-button,
.select-button,
.view-button,
.prev-view-btn,
.coords--button,
.next-view-btn {
  width: 25px;
  height: 25px;
  left: 9px;
  background-color: #304058;
  line-height: 0.4em;
} /*przyciski*/

.measure-icon,
.info-button__icon,
.select-button__icon,
.view-button__icon {
  width: 18px;
  height: 18px;
} /*przyciski icony*/

.measure-button,
.info-button,
.select-button,
.view-button,
.coords--button,
.prev-view-btn,
.next-view-btn,
#autocomplete-field,
#autosuggestType,
#autosuggest__clear-btn {
  position: absolute;
  z-index: 1;
} /*pozycja nad mapą*/

.measure-button,
.info-button,
.select-button,
.view-button,
.prev-view-btn,
.coords--button,
.next-view-btn,
#autosuggestType,
#autocomplete-field {
  border: 0.15em solid #b9b9b9;
  border-radius: 4px 4px 4px 4px;
} /*border*/

#autosuggestType,
#autocomplete-field {
  background-color: #fff;
} /*kolor podkładu*/
#autocomplete-field {
  left: 40px;
  width: 290px;
}
#autosuggestType {
  padding-left: 5px;
  left: 330px;
  width: 100px;
}
#autosuggest__clear-btn {
  left: 305px !important;
  font-size: 20px;
  margin-top: 2px;
}

.wrapper__viewer #autocomplete-field,
.wrapper__viewer #autosuggestType,
.wrapper__viewer #autosuggest__clear-btn {
  top: 33px;
} /*pozycja przy zwiniętym*/

.wrapper__viewer.expand #autocomplete-field,
.wrapper__viewer.expand #autosuggestType,
.wrapper__viewer.expand #autosuggest__clear-btn {
  top: 118px;
} /*pozycja przy rozwinientym*/

#autocomplete-field > input {
  padding-left: 5px;
  width: 260px;
}
#autocomplete-field > input:focus {
  outline: 0;
}
.autosuggest__results {
  max-height: 200px;
  overflow-y: auto;
  background: #fff;
}
#autosuggest__input {
  height: 22px;
}

ul[role="listbox"] {
  list-style: none;
  padding-left: 0;
  margin: 0;
}
ul[role="listbox"] > li:hover {
  background-color: #304058;
  color: #ffffff;
}
ul[role="listbox"] > li {
  cursor: pointer;
  transition: all 0.2s;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
}

.prev-view-btn {
  top: 125px;
} /*pozycja przy zwiniętym*/
.next-view-btn {
  top: 153px;
} /*pozycja przy zwiniętym*/
.measure-button {
  top: 181px;
} /*pozycja przy zwiniętym*/
.info-button {
  top: 209px;
} /*pozycja przy zwiniętym*/
.select-button {
  top: 237px;
} /*pozycja przy zwiniętym*/
.view-button {
  top: 265px;
} /*pozycja przy zwiniętym*/

.wrapper__viewer.expand .prev-view-btn {
  top: 210px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .next-view-btn {
  top: 238px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .measure-button {
  top: 266px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .info-button {
  top: 322px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .select-button {
  top: 350px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .view-button {
  top: 378px;
} /*pozycja przy rozwinientym*/
.wrapper__viewer.expand .coords--button {
  top: 294px;
}

.measure-results {
  height: auto;
  min-width: 100px;
  position: absolute;
  z-index: 1;
  left: 40px;
  top: 72px;
  padding: 3px;
  padding-bottom: 1px;
  border: 0.15em solid #b9b9b9;
  border-radius: 4px 4px 4px 4px;
  background-color: #304058;
  color: #ffffff;
}

.expand .measure-results {
  top: 155px;
}
#measure span.icon {
  margin-right: 0px;
}
.numeric-scale__container {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 50%;
  background-color: #304058 !important;
  color: white;
  opacity: 0.6;
  border-radius: 4px;
  bottom: 8px;
  padding: 2px;
  font-size: 10px;
}
.dialog-c-text {
  text-align: center;
}
</style>

<template>
  <div id="measure">
    <div
      class="measure-results"
      v-show="measuring"
    >
      Długość:
      <span v-text="length"></span>
      <br>Powierzchnia:
      <span v-html="area"></span>
    </div>
    <button
      class="prev-view-btn"
      @click="prevView"
      title="Poprzedni widok"
    >
      <span class="icon">
        <v-icon
          small
          color="white"
        >skip_previous</v-icon>
      </span>
    </button>
    <button
      class="next-view-btn"
      @click="nextView"
      title="Następny widok"
    >
      <span class="icon">
        <v-icon
          small
          color="white"
        >skip_next</v-icon>
      </span>
    </button>
    <button
      class="measure-button"
      v-show="!measuring"
      @click="addMeasure"
      title="Miarka"
    >
      <img
        class="measure-icon"
        :src="require('../../../assets/maptools/ruler.png')"
      >
    </button>
    <button
      class="measure-button"
      v-show="measuring"
      @click="removeMeasure"
    >
      <span class="icon">
        <v-icon
          small
          color="white"
        >clear</v-icon>
      </span>
    </button>
    <button
      class="coords--button"
      v-show="!isGetCoords"
      @click="startGetCoords"
      title="Współrzędne punktu"
    >
      <span class="icon">
        <v-icon
          dark
          small
        >
          my_location
        </v-icon>
      </span>
    </button>
    <button
      class="coords--button"
      v-show="isGetCoords"
      @click="stopGettingCoords"
      title="Wyłącz narzędzie"
    >
      <span class="icon">
        <v-icon
          dark
          small
        >
          clear
        </v-icon>
      </span>
    </button>
    <button
      class="info-button"
      title="Identyfikacja obiektów"
      v-show="!identification"
      @click="toggleIdentificationFeature"
    >
      <v-icon
        class="info-button__icon"
        dark
      >help_outline</v-icon>
    </button>
    <button
      class="info-button"
      v-show="identification"
      @click="toggleIdentificationFeature"
    >
      <span class="icon">
        <v-icon
          small
          color="white"
        >clear</v-icon>
      </span>
    </button>
    <button
      class="select-button"
      title="Zaznaczanie obiektów z warstwy aktywnej"
      v-show="currentBookmark === 'edition' && !selectFeatures"
      @click="toggleSelectFeatures"
    >
      <v-icon
        class="select-button__icon"
        dark
      >crop</v-icon>
    </button>
    <button
      class="select-button"
      v-show="currentBookmark === 'edition' && selectFeatures"
      @click="toggleSelectFeatures"
    >
      <span class="icon">
        <v-icon
          small
          color="white"
        >clear</v-icon>
      </span>
    </button>
    <button
      class="view-button"
      :title="currentEditedLayer ? 'Zasięg aktywnej warstwy' : 'Początkowy widok mapy'"
      @click="goToStartView"
    >
      <v-icon
        class="view-button__icon"
        dark
      >fullscreen</v-icon>
    </button>
    <div class="numeric-scale__container">1:{{numericScale}}</div>
  </div>
</template>

<script>
import {transform} from "ol/proj.js";

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
import filter from "lodash/filter";
import includes from "lodash/includes";
import first from "lodash/first";
import debounce from "lodash/debounce";
mixin(_, {
  chain,
  filter,
  includes,
  first,
  debounce
});
_.value = value;
_.prototype.value = value;

export default {
  data: () => ({
    measuring: false,
    length: undefined,
    area: undefined,
    identification: false,
    selectFeatures: false,
    autocompleteList: [],
    autocompleteListLabels: [],
    autocompleteFieldContent: "",
    numericScale: 0,
    isGetCoords: false,
    coords: undefined,
    coordsWGS: undefined
  }),
  computed: {
    currentBookmark() {
      return this.$store.getters.getCurrentBookmark;
    },
    currentEditedLayer() {
      return this.$store.getters.getCurrentEditedLayer;
    },
    map() {
      return this.$store.getters.getMap;
    },
    mapCenter() {
      return this.$store.getters.getMapCenter;
    },
    currentCoordSystem() {
      return this.$store.getters.getCurrentCoordSystem;
    },
  },
  methods: {
    onInputChange: _.debounce(function (val) {
      const self = this;
      let payload = {
        table: document.querySelector("#autosuggestType").value,
        term: val
      };
      this.$store.dispatch("getObject", payload).then(r => {
        self.autocompleteListLabels = [];
        self.autocompleteList = r;
        for(let el of r) {
          self.autocompleteListLabels.push(el.label);
        }
      });
    }, 500),
    clearAutosuggest() {
      this.$refs.autosuggestInput.searchInput = "";
      this.$root.$emit("removeMarker");
      this.autocompleteListLabels = [];
      this.autocompleteListLabels = [];
      //this.goToStartView();
    },
    showAddress(addr) {
      for(let el of this.autocompleteList) {
        if(addr.label == el.label) {
          this.$root.$emit("setPosition", [
            el.data.lat,
            el.data.lng,
            28,
            "marker"
          ]);
          break;
        }
      }
    },
    addMeasure() {
      this.clearTools();

      this.$root.$emit("addMeasure");
      this.measuring = true;
    },
    removeMeasure() {
      this.$root.$emit("removeMeasure");
      this.length = 0;
      this.area = 0;
      this.measuring = false;
    },
    prevView() {
      history.back();
    },
    nextView() {
      history.forward();
    },
    getCoords(e) {
      this.coords = transform(e.coordinate, this.$root.projection, this.getCurrentCoordSystem())
        .map(coord => coord.toFixed(5));
      
      this.$emit("confDialogOpened", true);
      this.$modal.show("dialog", {
        title: "WSPÓŁRZĘDNE KURSORA",
        text: `Współrzędne kursora w układzie ${this.currentCoordSystem} (${this.getCurrentCoordSystem()}): <span style="font-weight: bolder" class="coords__wrapper">${this.coords[0]}, ${this.coords[1]}</span>`,
        buttons: [
          {
            title: "Kopiuj współrzędne",
            handler: () => {
              let txt = document.getElementsByClassName('coords__wrapper');
              let selection = window.getSelection();
              let range = document.createRange();
              range.selectNodeContents(txt[0]);
              selection.removeAllRanges();
              selection.addRange(range);
              document.execCommand('copy');
              selection.removeRange(range);
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              this.stopGettingCoords();
              return;
            }
          }, {
            title: "Zamknij",
            default: true,
            handler: () => {
              this.stopGettingCoords()
              this.$emit("confDialogOpened", false);
              this.$modal.hide("dialog");
              return;
            }
          }
        ],
      })

    },
    getCurrentCoordSystem() {
      if (this.currentCoordSystem === "WGS84") {
        return "EPSG:4326";
      } else if (this.currentCoordSystem  === "1992") {
        return "EPSG:2180";
      } else {
        return this.$store.getters.getSrid;
      }
    },
    goToStartView() {
      const self = this;
      if(self.currentEditedLayer) {
        const layer = _.chain(
          self.map
            .getLayers()
            .item(2)
            .getLayers()
            .getArray()
        )
          .filter(
            layer =>
              _.includes(["water", "sewer"], layer.get("layer_type")) &&
              layer.get("full_type") === self.currentEditedLayer
          )
          .first()
          .value();

        let extent = [];
        if(layer) {
          extent = layer.getSource().getExtent();
        }
        if(extent && extent.length === 4) {
          self.map.getView().fit(extent);
          return;
        }
      }

      self.$root.$emit("setPosition", [283923.09, 366192.07, 15]);
    },
    setData(data) {
      this.length = data[0];
      this.area = data[1];
    },
    setNumericScale(data) {
      this.numericScale = data;
    },

    toggleIdentificationFeature() {
      if(!this.identification) {
        this.clearTools();
      }
      this.identification = !this.identification;
      this.$root.$emit(
        "identificationFeature",
        this.identification ? "start" : "cancel"
      );
      this.$store.dispatch('getUserLayers')
    },
    toggleSelectFeatures() {
      if(!this.selectFeatures) {
        this.clearTools();
      }
      this.selectFeatures = !this.selectFeatures;
      this.$root.$emit(
        "selectFeatures",
        this.selectFeatures ? "start" : "cancel"
      );
    },
    toDegreesMinutesAndSeconds(coordinate) {
      let absolute = Math.abs(coordinate);
      let degrees = Math.floor(absolute);
      let minutesNotTruncated = (absolute - degrees) * 60;
      let minutes = Math.floor(minutesNotTruncated);
      let seconds = Math.floor((minutesNotTruncated - minutes) * 60);

      return degrees + "° " + minutes + "\' " + seconds + "\" ";
    },
    clearTools() {
      if(this.identification) {
        this.toggleIdentificationFeature();
      }
      if(this.selectFeatures) {
        this.toggleSelectFeatures();
      }
      if(this.measuring) {
        this.removeMeasure();
      }
    },
    startGetCoords() {
      document.getElementsByTagName('canvas')[0].style.cursor = 'crosshair';
      this.isGetCoords = true;
      this.map.on('click', this.getCoords);
    },
    stopGettingCoords() {
      this.map.un('click', this.getCoords);
      document.getElementsByTagName('canvas')[0].style.cursor = 'default';
      // document.removeEventListener('click', this.map);
      this.isGetCoords = false;
    },
  },
  mounted() {
    this.$root.$on("measureData", this.setData);
    this.$root.$on("identificationFeature", type => {
      if(type === "stop") {
        this.identification = false;
      }
    });
    this.$root.$on("selectFeatures", type => {
      if(type === "stop") {
        this.selectFeatures = false;
      }
    });
    this.$root.$on('setNumericScale', this.setNumericScale)
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/measureTools/MeasureTools.vue